// SCRUM-449: shared filename builder for all downloadable reports.
// Format: YYYY-MM_AccountName_doctype_Program.ext
// Patient files: YYYY-MM_AccountName_PatientFirstName_PatientLastName_doctype_Program.ext
// Source of truth: Toca_File_Naming_Convention_v2.xlsx + Doubts_ Report Naming Convention .xlsx

export const DOCTYPES = {
  BILLING: "billing",
  CAREPLAN: "careplan",
  REPORT: "report",
  AUDIT: "audit",
  ALL_READINGS: "allreadings",
  // Reserved for a future "All Data" export on DailiesReadingsPanel's all-data tab.
  // No call site produces this yet — the tab has no download button (SCRUM-449).
  ALL_DATA: "alldata",
  UNREVIEWED_READINGS: "unreviewedreadings",
  REVIEWED_READINGS: "reviewedreadings",
  ESCALATED_READINGS: "escalatedreadings",
  OOR_CATEGORY: "oorcategory",
  OOR_LIST: "oorlist",
  OOR_EXTENDED_THRESHOLD: "oorextendedthreshold",
  OOR_SUMMARY: "oorsummary",
};

export const sanitizeAccountName = (name) => {
  if (!name) return "Unknown";
  return name.replace(/[^a-zA-Z0-9]/g, "_");
};

// Patient names keep whatever casing is already stored on the record; only
// hyphens/apostrophes are stripped (e.g. "Mary-Jane" -> "MaryJane", "O'Brien" -> "OBrien").
export const sanitizePatientNamePart = (name) => {
  if (!name) return "";
  return name.replace(/[-']/g, "");
};

const pad2 = (n) => String(n).padStart(2, "0");

const nowInPST = () =>
  new Date(new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

export const getReportPeriod = (year, month) => {
  if (year && month) {
    return `${year}-${pad2(month)}`;
  }
  const now = nowInPST();
  return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}`;
};

export const buildProgramSegment = (program) => {
  if (!program) return "";
  const programs = Array.isArray(program) ? program : [program];
  return programs.filter(Boolean).map((p) => p.toUpperCase()).join("_");
};

export const buildReportFilename = ({
  accountName,
  year,
  month,
  patientFirstName,
  patientLastName,
  doctype,
  program,
  ext,
}) => {
  const account = sanitizeAccountName(
    accountName !== undefined ? accountName : sessionStorage.getItem("acc_name")
  );
  const parts = [getReportPeriod(year, month), account];

  const first = sanitizePatientNamePart(patientFirstName);
  const last = sanitizePatientNamePart(patientLastName);
  if (first) parts.push(first);
  if (last) parts.push(last);

  parts.push(doctype);

  const programSegment = buildProgramSegment(program);
  if (programSegment) parts.push(programSegment);

  return `${parts.join("_")}.${ext}`;
};
